import { useMemo, useState } from 'react'
import clsx from 'clsx'
import styles from './DurationInput.module.css'

type DurationUnit = 'seconds' | 'minutes'

interface DurationInputProps {
  value: number
  unit: DurationUnit
  onChange: (valueSeconds: number, valueRaw: number, unit: DurationUnit) => void
  className?: string
  placeholder?: string
  label?: string
}

export function DurationInput({
  value,
  unit,
  onChange,
  className,
  placeholder = '',
  label,
}: DurationInputProps) {
  const [isFocused, setIsFocused] = useState(false)
  const [inputText, setInputText] = useState<string>('')

  const displayedValue = useMemo(() => {
    if (!Number.isFinite(value)) return 0
    return unit === 'minutes' ? Math.floor(value / 60) : value
  }, [value, unit])

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value
    setInputText(next)

    if (next === '') {
      onChange(0, 0, unit)
      return
    }

    const raw = Number(next)
    if (Number.isNaN(raw) || raw < 0) {
      return
    }
    const seconds = unit === 'minutes' ? raw * 60 : raw
    onChange(seconds, raw, unit)
  }

  const handleUnitChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const nextUnit = e.target.value as DurationUnit
    const raw = nextUnit === 'minutes' ? Math.floor(value / 60) : value
    const seconds = nextUnit === 'minutes' ? raw * 60 : raw
    onChange(seconds, raw, nextUnit)
  }

  return (
    <div className={clsx(styles.container, className)}>
      {label && <label className={styles.label}>{label}</label>}
      <input
        type="number"
        min={0}
        value={isFocused ? inputText : String(displayedValue)}
        onChange={handleValueChange}
        placeholder={placeholder}
        onFocus={() => {
          setIsFocused(true)
          setInputText(displayedValue === 0 ? '' : String(displayedValue))
        }}
        onBlur={() => {
          setIsFocused(false)
          setInputText('')
        }}
        className={styles.input}
      />
      <select
        value={unit}
        onChange={handleUnitChange}
        className={styles.select}
      >
        <option value="seconds">сек</option>
        <option value="minutes">мин</option>
      </select>
    </div>
  )
}


